import { FormGroup } from '@mui/material';
import * as coreApi from "api/Core";
import { Constants } from 'assets/appConfig';
import { ReactAutoComplete, ReactAutoCompleteProps } from 'components/AutoComplete';
import HtmlUtils from 'lib/HtmlUtils';
import { MemberType } from 'models/ApiEnums';
import { MemberSuggestionDto } from 'models/ApiModels';
import * as React from 'react';
import { RoutePaths } from 'routes/RouteConfig';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export type MemberAutoCompleteSearchParams = {
    searchText: string,
    usersOnly: boolean,
    excludeCurrentUser: boolean,
    offset: number,
    take: number;
};

interface IState {
}

interface IProps extends Omit<ReactAutoCompleteProps, "selectedItems" | "onGetSuggestions" | "onChange" | "onValidate" | "onSelectedItemClick"> {
    selectedItems?: Array<MemberSuggestionDto>;
    showUsersOnly?: boolean;

    onChange: (data: MemberSuggestionDto[]) => void;
    onValidate?: (item: MemberSuggestionDto) => boolean;
    onCustomItemClick?: () => void;
    onCustomGetMembers?: (p: MemberAutoCompleteSearchParams) => Promise<MemberSuggestionDto[]>;
}

type Props = IProps;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export default class MemberAutoComplete extends React.PureComponent<Props, IState> {

    private apiGetData = coreApi.getMemberSuggestions();

    ///
    constructor(props: Props) {
        super(props);
        this.state = { dialog: null };
    }

    ///
    static defaultProps = {
        autoFocus: false,
        showUsersOnly: false
    };

    ///
    private getMembers(searchText: string, skipRecords: number, takeRecords: number): Promise<MemberSuggestionDto[]> {
        const inputValue = searchText.trim().toLowerCase();

        return this.props.onCustomGetMembers
            ? this.props.onCustomGetMembers({
                searchText: inputValue,
                usersOnly: false,
                excludeCurrentUser: false,
                offset: skipRecords,
                take: takeRecords,
            })
            : this.apiGetData.execute({
                searchText: inputValue,
                usersOnly: this.props.showUsersOnly,
                excludeCurrentUser: false,
                offset: skipRecords,
                take: takeRecords
            });
    }

    ///
    private updateMembers(items: Array<MemberSuggestionDto>) {
        this.props.onChange(items);
    }

    ///
    private handleMemberClick = (item: MemberSuggestionDto) => {
        if (item.key == Constants.EmptyGuid) {
            if (this.props.onCustomItemClick) this.props.onCustomItemClick();
        }
        else {
            HtmlUtils.openUrlInNewWindow(
                item.memberType == MemberType.User
                    ? RoutePaths.UserProfileViewer.replace(":id", item.key)
                    : RoutePaths.GroupProfileViewer.replace(":id", item.key)
            );
        }
    };

    ///
    public render() {
        const { selectedItems, onValidate, ...rest } = this.props;

        return (

            <FormGroup>
                {
                    <ReactAutoComplete
                        {...rest}
                        selectedItems={selectedItems}
                        onGetSuggestions={(searchText, skipRecords, takeRecords) => this.getMembers(searchText, skipRecords, takeRecords)}
                        onSelectedItemClick={(item) => this.handleMemberClick(item as MemberSuggestionDto)}
                        onChange={(items) => this.updateMembers(items as MemberSuggestionDto[])}
                        onValidate={(item) => onValidate ? onValidate(item as MemberSuggestionDto) : true}
                    />
                }

            </FormGroup>
        );
    }
}